module.exports = __webpack_public_path__ + "img/food6.1ae0b65e.png";